import { apiFetch } from './client';
import type { Tenant } from '@/types/api';

export interface CustomDomainState {
  readonly domain: string | null;
  readonly status: 'pending' | 'verified' | 'failed' | 'none';
  readonly txtRecord?: { name: string; value: string };
  readonly verifiedAt?: string | null;
}

export type SubdomainAvailabilityReason =
  | 'ok'
  | 'invalid_format'
  | 'reserved'
  | 'taken'
  | 'empty';

export interface SubdomainAvailability {
  readonly value: string;
  readonly available: boolean;
  readonly reason: SubdomainAvailabilityReason;
}

export const tenantApi = {
  get(): Promise<Tenant> {
    return apiFetch<Tenant>('/tenant');
  },

  checkSubdomain(value: string): Promise<SubdomainAvailability> {
    return apiFetch<SubdomainAvailability>('/tenant/subdomain/check', {
      searchParams: { value },
    });
  },

  setSubdomain(subdomain: string): Promise<Tenant> {
    return apiFetch<Tenant>('/tenant/subdomain', {
      method: 'POST',
      body: { subdomain },
    });
  },

  getCustomDomain(): Promise<CustomDomainState> {
    return apiFetch<CustomDomainState>('/tenant/custom-domain');
  },

  setCustomDomain(domain: string): Promise<CustomDomainState> {
    return apiFetch<CustomDomainState>('/tenant/custom-domain', {
      method: 'POST',
      body: { domain },
    });
  },

  verifyCustomDomain(): Promise<CustomDomainState> {
    return apiFetch<CustomDomainState>('/tenant/custom-domain/verify', { method: 'POST' });
  },

  clearCustomDomain(): Promise<void> {
    return apiFetch<void>('/tenant/custom-domain', { method: 'DELETE' });
  },
};
